import React from 'react';
// @ts-ignore
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress, Grid, Paper, Typography } from '@material-ui/core';
import { setDepartmentOmbudsman } from '../../redux/actions/f5-actions/department-ombudsman';

import CustomCard from './CustomCard';

const colors = {
    156: 'rgba(28, 47, 156, 0.85)',
    ouv_geral: 'rgba(156, 137, 28, 0.85)',
    ouv_saude: 'rgba(43, 156, 28, 0.85)',
    ouv_guarda: 'rgba(156, 26, 44, 0.85)',
};

export type Sector = {
    id: number;
    nome: string;
    interno: '156' | 'ouv_geral' | 'ouv_saude' | 'ouv_guarda';
    count: number;
    pendente: number;
    solucionada: number;
    dentroPrazo: number;
    aVencer: number;
    vencidas: number;
}

interface ChooseSectorProps {
    sectors: Sector[];
}

const ChooseSector = ({ sectors }: ChooseSectorProps) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (office: string) => {
        dispatch(setDepartmentOmbudsman(office));
        history.push('/ocorrencias');
    };

    return <Grid container spacing={2}>
        {sectors.length > 0 ?
            sectors.map(item => (
                <Grid item xs={12} key={item.id}>
                    <CustomCard
                        color={colors[item.interno]}
                        title={item.nome}
                        count={item.count}
                        handleClick={() => handleClick(item.interno)}
                        data={{
                            pending: item.pendente,
                            solved: item.solucionada,
                            ontime: item.dentroPrazo,
                            due: item.aVencer,
                            overdue: item.vencidas,
                        }}
                    />
                </Grid>
            )) : <Box width="100%" height={150} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                <CircularProgress />
                <Box fontWeight={700} fontSize={12}>
                    Carregando dados...
                </Box>
            </Box>}
    </Grid>
};

export default ChooseSector;
